/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import {
  type UseMutationResult,
  type UseQueryResult,
  useMutation,
  useQueryClient,
  useQuery,
} from '@tanstack/react-query';

import {
  type AvailabilitySlotPayload,
  type AvailabilityWindow,
  availabilityApi,
} from '../api/availability.js';

const AVAILABILITY_KEY = ['availability'] as const;

export function useMyAvailability(): UseQueryResult<readonly AvailabilityWindow[]> {
  return useQuery({ queryKey: AVAILABILITY_KEY, queryFn: () => availabilityApi.listMine() });
}

export function useSetAvailability(): UseMutationResult<
  readonly AvailabilityWindow[],
  Error,
  readonly AvailabilitySlotPayload[]
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (slots: readonly AvailabilitySlotPayload[]) => availabilityApi.setMine(slots),
    onSuccess: (windows) => {
      qc.setQueryData(AVAILABILITY_KEY, windows);
    },
  });
}
